
      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire004f"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire004f"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("aSaL0", function(module, exports) {
'use strict';

var $l96AT = parcelRequire("l96AT");
module.exports = (url)=>$l96AT(url) && true;

});
parcelRegister("l96AT", function(module, exports) {
'use strict';
const $f64f8db0ffa1dbf3$var$REGEX_HTTP_PROTOCOL = /^https?:\/\//i;
module.exports = (url)=>{
    try {
        const { href: href } = new URL(url);
        return $f64f8db0ffa1dbf3$var$REGEX_HTTP_PROTOCOL.test(href) && href;
    } catch (err) {
        return false;
    }
};

});



window.addEventListener("load", (event)=>{
    const isVaildURL = (parcelRequire("aSaL0"));
    const properties = new Map();
    properties.set("brookedotbike", {
        title: "Brooke.bike",
        url: "https://brooke.bike",
        tagline: "A log of bicycle travel."
    });
    properties.set("brookedotblog", {
        title: "Brooke.blog",
        url: "https://brooke.blog",
        tagline: "A blog of personal musings."
    });
    properties.set("brookedotcodes", {
        title: "Brooke.codes",
        url: "https://brooke.codes",
        tagline: "A technical journal for the modern era."
    });
    properties.set("brookedotis", {
        title: "Brooke.is",
        url: "https://brooke.is",
        tagline: "A delightful attempt at an explanation. "
    });
    properties.set("brookedotphoto", {
        title: "Brooke.photo",
        url: "https://brooke.photo",
        tagline: "A photo a day, sometimes."
    });
    /* 
     * Loop through the "property" class and handle click acctions 
     */ var propClass = document.getElementsByClassName('property');
    for(var i = 0; i < propClass.length; i++)propClass[i].addEventListener("click", function(e) {
        e.preventDefault();
        removeProperty();
        // get the data property value
        let propertyKey = this.dataset.property;
        // ensure the value is in the properties array map 
        if (properties.has(propertyKey)) {
            let property = properties.get(propertyKey);
            // add the current key as body class
            document.body.classList.add(propertyKey);
            // update title
            if ('title' in property) {
                let title = document.getElementById("property");
                title.innerHTML = property['title'];
                // add large icon
                let icon = document.createElement('p');
                icon.innerHTML = '<i class="icon icon-' + propertyKey + '"></i>';
                icon.classList = 'is-hidden-mobile';
                icon.id = 'icon-large';
                title.parentNode.insertBefore(icon, title);
            }
            // update tagline
            if ('tagline' in property) {
                let tagline = document.getElementById("tagline");
                tagline.innerHTML = property['tagline'];
                // validate and add the site URL Button
                if ('url' in property && isVaildURL(property['url'])) {
                    let button = document.createElement('p');
                    button.innerHTML = '<a href = "' + property['url'] + '"><button class="button ">Visit Site</button></a>';
                    button.classList = 'subtitle my-4';
                    button.id = 'url';
                    tagline.parentNode.insertBefore(button, tagline.nextSibling);
                }
            }
        }
    }, false);
    /* 
     * Contact Link in top nav
     */ document.querySelector(".contact").addEventListener("click", (e)=>{
        e.preventDefault();
        removeProperty();
        document.getElementById("property").innerHTML = "Contact Brooke.";
        document.getElementById("tagline").innerHTML = "hi[at]broo.ke";
        document.body.classList.add('contact');
    });
    /* 
     * Helper function to remove all body classes and added elements (icon & link button)
     */ function removeProperty() {
        const removeURL = document.getElementById('url');
        const removeIcon = document.getElementById('icon-large');
        if (removeURL) removeURL.remove();
        if (removeIcon) removeIcon.remove();
        // remove each properties map value from the body class
        properties.forEach((value, key)=>{
            document.body.classList.remove(key);
        });
        document.body.classList.remove('contact');
    }
    /* 
     * Dark Mode Toggle 
     * https://dev.to/whitep4nth3r/the-best-lightdark-mode-theme-toggle-in-javascript-368f
     */ function isThemeSet({ localStorageTheme: localStorageTheme, systemSettingDark: systemSettingDark }) {
        if (localStorageTheme !== null) return localStorageTheme;
        if (systemSettingDark.matches) return "dark";
        return "light";
    }
    const localStorageTheme = localStorage.getItem("theme");
    const systemSettingDark = window.matchMedia("(prefers-color-scheme: dark)");
    const darkmodeToggle = document.querySelector(".theme-toggle");
    const toggleClass = "theme-toggle--toggled";
    let currentThemeSetting = isThemeSet({
        localStorageTheme: localStorageTheme,
        systemSettingDark: systemSettingDark
    });
    if (currentThemeSetting === "dark") {
        darkmodeToggle.classList.add(toggleClass);
        darkmodeToggle.setAttribute("aria-label", "Change to light theme");
        darkmodeToggle.setAttribute("title", "Change to light theme");
        document.querySelector("html").setAttribute("data-theme", "dark");
    }
    darkmodeToggle.addEventListener("click", (e)=>{
        e.preventDefault();
        const setTheme = currentThemeSetting === "dark" ? "light" : "dark";
        const ariaText = setTheme === "dark" ? "Change to light theme" : "Change to dark theme";
        darkmodeToggle.classList.toggle(toggleClass);
        darkmodeToggle.setAttribute("aria-label", ariaText);
        darkmodeToggle.setAttribute("title", ariaText);
        document.querySelector("html").setAttribute("data-theme", setTheme);
        localStorage.setItem("theme", setTheme);
        currentThemeSetting = setTheme;
    });
});


//# sourceMappingURL=main.2ec84dd1.js.map
